import React, { useEffect } from "react";
import { string, func } from "prop-types";
import { connect } from "react-redux";

import ForgotPassword from "../../rows/ForgotPassword";
import { setCurrentPath } from "../../helper/actions";

const ForgotPasswordPageBase = ({ currentPath, setCurrentPath }) => {
  useEffect(() => {
    setCurrentPath(currentPath);
  }, []);

  return (
    <React.Fragment>
      <ForgotPassword currentPath={currentPath} />
    </React.Fragment>
  );
};

ForgotPasswordPageBase.propTypes = {
  currentPath: string,
  setCurrentPath: func,
};

const mapDispatchToProps = (dispatch) => ({
  setCurrentPath: (path) => dispatch(setCurrentPath(path)),
});

export const ForgotPasswordPage = connect(null, mapDispatchToProps)(ForgotPasswordPageBase);
